export default superclass => class extends superclass  {
    addRackEffect(fx, onBack=true, effect, outputNumber) {
        console.log('add rack effect output=', outputNumber);
        let rack = this.effectRack;
        let adj = rack.adjacencyLists;
        rack.addEffect(fx);
        
        if (effect) {
            let edges = (adj[effect.id] && adj[effect.id].filter(e => e.outputNumber === outputNumber)) || [];
            let nodes = edges.map(e => e.effect);
            edges.forEach(e => rack.deleteEdge(e));
            nodes.forEach(n => rack.connectNodes(fx, n));
            rack.connectNodes(effect, fx, outputNumber);
        } else if (onBack) {
            if (rack.effects.length > 1) {
                let edge;
                let _fx = undefined;
                for (let id in adj) {
                    let _edge = adj[id].find(e => e.effect === rack.outputNode);
                    if (_edge) {
                        _fx = rack.effects.find(e => e.id === id);
                        edge = _edge;
                        break;
                    }
                }
                
            rack.deleteEdge(edge);
                rack.connectNodes(
                    _fx,
                    fx,
                );
            } else {
                rack.connectNodes(
                    undefined, 
                    fx
                );
            }
            rack.connectNodes(
                fx
            );
        } else {
            // at front
            let adj = rack.adjacencyLists[-1];
            if (rack.effects.length > 1 && adj.length > 0) {
                let {effect} = adj[0];
                rack.deleteEdge(adj[0]);
                rack.connectNodes(fx, effect);
            } else {
                rack.connectNodes(fx);
            }
            rack.connectNodes(undefined, fx);
        }
    }
}
